import React, { useState, useEffect } from "react";

import HorizontalListItem from "../components/HorizontalListItem";
import VerticalListItem from "../components/VerticalListItem";
import PageHeader from "../components/PageHeader";
import OfferBottomSheet, { OfferCard } from "../components/OfferBottomSheet";

const AppsPage = ({ handleItemClick, handleSearchEvent, showOverlayHeader, gamesData, homeOffers = [] }) => {
  const [filteredGames, setFilteredGames] = useState([]);
  const [selectedOffer, setSelectedOffer] = useState(null);

  useEffect(() => {
    const newFilteredGames = gamesData.filter((game) => game.category === "2");
    setFilteredGames(newFilteredGames.slice());
  }, [gamesData]);

  return (
    <div className="flex flex-col relative w-full bg-gradient-to-r from-semi-blue to-light-blue">
      <PageHeader onSearchClick={() => handleSearchEvent && handleSearchEvent("Search")} />

      {showOverlayHeader && (
        <div className="fixed top-0 left-1/2 -translate-x-1/2 w-full max-w-md md:max-w-lg z-40 backdrop-blur-2xl animate-appear rounded-b-xl shadow-md bg-light-blue/60">
          <PageHeader onSearchClick={() => handleSearchEvent && handleSearchEvent("Search")} />
        </div>
      )}

      {homeOffers.length > 0 && (
        <>
          <h2 className="text-white medium text-2xl mx-4 tracking-wide mt-4">
            You May Like
          </h2>
          <div className="flex overflow-x-scroll pb-4 hide-scroll-bar mt-2 mx-2">
            <div className="grid grid-flow-col grid-rows-2 gap-4">
              {homeOffers.map((offer, index) => (
                <OfferCard key={index} offer={offer} onPress={setSelectedOffer} />
              ))}
            </div>
          </div>
        </>
      )}

      <div className="h-px bg-gray-700 mx-4" />

      <div className="flex flex-row justify-between items-baseline mx-4 mt-4">
        <h2 className="text-white medium text-3xl">All Apps</h2>
      </div>

      {filteredGames.map((item) => (
        <VerticalListItem
          key={item.id}
          game={item}
          handleItemClick={handleItemClick}
        />
      ))}

      <div className="h-20"></div>

      <OfferBottomSheet
        offer={selectedOffer}
        onClose={() => setSelectedOffer(null)}
      />
    </div>
  );
};

export default AppsPage;
